import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { ReturnService } from '../return.service';

@Component({
  selector: 'app-return-dashboard',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './return-dashboard.component.html',
  styleUrls: ['./return-dashboard.component.scss'],
})
export class ReturnDashboardComponent implements OnInit, OnDestroy {
  tabSelected = 'createReturn';
  userDetails: any;
  activeRouteSub: Subscription;
  userSub: Subscription;
  serviceEmitSub: Subscription;
  accDatasub: Subscription;

  constructor(
    private readonly user: UserAccountFacade,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly cd: ChangeDetectorRef,
    private readonly service: ReturnService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activeRouteSub = this.activatedRoute.queryParams.subscribe((res) => {
      if (res.hasOwnProperty('page')) {
        if (res.page == 'createReturn') {
          this.tabSelected = 'createReturn';
          document.getElementById('createReturn').style.display = 'block';
          document.getElementById('returnHistory').style.display = 'none';
        } else if (res.page == 'returnHistory') {
          this.tabSelected = 'returnHistory';
          document.getElementById('createReturn').style.display = 'none';
          document.getElementById('returnHistory').style.display = 'block';
        }
        this.cd.detectChanges();
      } else {
        this.tabNavigation('createReturn', 'createReturn');
      }
    });

    this.userSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      if (this.userDetails) this.getUserAccountData(this.userDetails.userName);
    });

    this.serviceEmitSub = this.service.emitReturnHistory.subscribe((res) => {
      if (res) {
        this.tabNavigation('returnHistory', 'returnHistory');
        window.scroll(0, 0);
      }
    });
  }

  ngOnDestroy(): void {
    this.activeRouteSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.serviceEmitSub?.unsubscribe();
    this.accDatasub?.unsubscribe();
  }

  tabNavigation(content, id) {
    const idArray = ['createReturn', 'returnHistory'];
    this.tabSelected = content;
    for (const item of idArray) {
      if (id === item) {
        document.getElementById(item).style.display = 'block';
      } else {
        document.getElementById(item).style.display = 'none';
      }
    }
  }

  getUserAccountData(userId): void {
    this.pfService.getUserAccountDataFromDb(userId);
    this.accDatasub = this.pfService.userAccountData.subscribe((userData) => {
      if (userData?.res && userData?.res?.length !== 0) {
        this.service.userAccountInfo.next(userData);
        this.cd.detectChanges();
      }
    });
  }
}
